export default "__VITE_ASSET__2a3jY4yX__"